import { render } from "./WCMobileHeader.vue?vue&type=template&id=54687a6e&scoped=true"
import script from "./WCMobileHeader.vue?vue&type=script&lang=js"
export * from "./WCMobileHeader.vue?vue&type=script&lang=js"

import "./WCMobileHeader.vue?vue&type=style&index=0&id=54687a6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54687a6e"]])

export default __exports__